import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from "react-router-dom";
import condicionesServices from '../../services/condicionesServices';
import { InputContext } from '../../contexts/InputContext';
import MessageModal from '../../container/MessageModal';
import { errorClassification } from '../../errorHandler';

const ListaCondiciones = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)

  const [condiciones, setCondiciones] = useState([]);
  const [renderHTML, setRenderHTML] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  useEffect(() => {
    obtenerCondiciones();
  }, []);

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin')){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const obtenerCondiciones = async () => {
    try {
      const data = await condicionesServices.obtenerCondiciones();

      setCondiciones(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const eliminarCondicion = async (condicion) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar a ${condicion.nombre}?`)){
        await condicionesServices.eliminarCondicion(condicion.id);

        const copiaCondiciones = [...condiciones];
        setCondiciones(copiaCondiciones.filter((condiciones) => condiciones.id !== condicion.id))
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const listarCondiciones = condiciones && condiciones.map((condicion, index) => {
    return (
      <tr key={index}>
        <td>{condicion.nombre}</td>
        <td>
          <div className="btn-group" role="group">
            <Link className="btn btn-primary" to={`/condicion/${condicion.id}/edit`}>Editar</Link>{' '}
            <button className="btn btn-danger" onClick={()=>eliminarCondicion(condicion)} >Eliminar</button>
          </div>
        </td>
    </tr>
    )
  })

  return (
    <>
      <h1>Lista de condiciones</h1>
      {
        (renderHTML) && (
          <>
          <div className="table-responsive small">
            <table className="table table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Acción</th>
                </tr>
              </thead>
              <tbody>
                {listarCondiciones}
              </tbody>
            </table>
          </div>
          </>
        )
      }
      <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
      </>

  );
};

export default ListaCondiciones;